// components/Wrapper.js
import React from "react";

interface WrapperProps {
    children: React.ReactNode;
}

const ICMWrapper: React.FC<WrapperProps> = ({ children }) => {
return <div className="md:px-auto mx-auto px-6 md:container max-w-[100%]">{children}</div>;
};

export default ICMWrapper;
